const InforView = () => {
    return (
        <div>
            <h1>현재 점검중에 있습니다.</h1>
        </div>
    )
}

export default InforView;
